'use client'

// Kartu ringkas per project tim: progress, jumlah task, on-time. Klik → filter board.
import { FolderKanban } from 'lucide-react'
import { isoDay, diffDays } from '@/lib/dev-sprint'
import type { BoardData, DevDerived } from './types'

interface Props {
  board: BoardData
  derived: DevDerived
  activeProject: string | null
  onFilterProject: (id: string | null) => void
}

export function ProjectOverview({ board, derived, activeProject, onFilterProject }: Props) {
  const { statusOf } = derived
  if (board.projects.length === 0) return null

  const cards = board.projects.map((p) => {
    const tasks = board.tasks.filter((t) => t.projectId === p.id)
    const total = tasks.length
    const done = tasks.filter((t) => statusOf(t) === 'done').length
    let doneCount = 0, onTime = 0
    for (const t of tasks) {
      if (statusOf(t) !== 'done') continue
      doneCount++
      const due = isoDay(t.dueDate)
      const fin = isoDay(t.tanggalSelesai) || due
      if (!due || !fin || fin <= due) onTime++
    }
    return {
      project: p,
      total,
      done,
      pct: total ? Math.round((done / total) * 100) : 0,
      onTimePct: doneCount ? Math.round((onTime / doneCount) * 100) : null,
    }
  })

  return (
    <div className="mt-4">
      <div className="flex items-center gap-2 mb-2">
        <FolderKanban className="w-3.5 h-3.5 text-[#8B8A85]" />
        <h3 className="text-[13px] font-bold text-[#1A1916]">Project Tim</h3>
        <span className="text-[11px] text-[#AEADA8]">{cards.length} project · klik untuk filter</span>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1">
        {cards.map(({ project, total, done, pct, onTimePct }) => {
          const active = activeProject === project.id
          return (
            <button
              key={project.id}
              onClick={() => onFilterProject(active ? null : project.id)}
              className={`flex-shrink-0 w-[220px] text-left rounded-2xl border bg-white p-3 transition-all ${active ? 'border-[#1A1916] ring-1 ring-[#1A1916]' : 'border-[#E7E5DF] hover:border-[#C9C7C0]'}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: project.color }} />
                <span className="text-[13px] font-semibold text-[#1A1916] truncate flex-1">{project.name}</span>
              </div>
              <div className="h-1.5 rounded-full bg-[#F0EEE7] overflow-hidden mb-2">
                <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: project.color }} />
              </div>
              <div className="flex items-center justify-between text-[11px]">
                <span className="text-[#8B8A85] tabular-nums">{done}/{total} task · {pct}%</span>
                {onTimePct != null && (
                  <span className="tabular-nums font-semibold" style={{ color: onTimePct >= 80 ? '#1E7A46' : onTimePct >= 50 ? '#9A6B00' : '#C0362C' }}>
                    {onTimePct}% on-time
                  </span>
                )}
              </div>
              {project.deadline && (
                <p className="text-[10px] text-[#AEADA8] mt-1.5 tabular-nums">
                  Deadline {isoDay(project.deadline).slice(5)} · {(() => { const d = diffDays(new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10), isoDay(project.deadline)); return d < 0 ? `lewat ${-d}h` : `${d}h lagi` })()}
                </p>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
